import API from '@/lib/API.js'
import comun from './comun.js'
const aportesafiliado = {
    namespaced: true,
    state: {
        Lista: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state = {
                Lista: [],
                Seleccionado: undefined
            };
        },
        set(state, valor) {
            state.Lista = valor;
        },
        select(state, valor) {
            state.Seleccionado = valor;
        },
    },
    actions: {
        async traerPorCuil({
            commit
        }, valor) {
            commit("comun/cargando")
            let data = []
            data = await API.Aportesafiliado.traerPorCuil(valor);
            commit("set", data)
            commit("comun/fincarga")
        },
    },
    modules: {
        comun,
    }

}
export default aportesafiliado;